import {NgIf} from '@angular/common';
import {CommonModule} from '@angular/common';
import {AfterViewInit, HostListener, OnChanges, OnInit} from '@angular/core';
import {Component, SimpleChanges, TemplateRef, ViewChild} from '@angular/core';
import {MatButtonModule} from '@angular/material/button';
import {MatCardModule} from '@angular/material/card';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {CustomizerSettingsService} from "../../../../customizer-settings/customizer-settings.service";
import {ApiService} from "../../../_services/api.service";
import {Endpoints} from "../../../endpoints";
import {NgxSpinnerService} from "ngx-spinner";
import {DialogService} from "../../../_modal/dialog.service";
import {finalize, tap} from "rxjs";
import {environment} from "../../../../../environments/environment";
import {FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators} from "@angular/forms";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {MatError, MatFormField, MatLabel, MatSuffix} from "@angular/material/form-field";
import {MatInput, MatInputModule} from "@angular/material/input";
import {MatAutocompleteModule, MatOption} from "@angular/material/autocomplete";
import {MatSelect} from "@angular/material/select";
import {OverlayContainer} from "@angular/cdk/overlay";
import {MatSort, MatSortModule} from "@angular/material/sort";
import * as pdfGenerator from 'jspdf';
import JsBarcode from 'jsbarcode';
import {ChangeDetectorRef} from '@angular/core';
import {SampleAffectationRequest, SampleDTO, SampleStatus} from "../../../_models/sampleDTO";
import {SampleStatusDto} from "../../../_models/Sample.status.dto";
import {ShortClientDto} from "../../../_models/client.dtos";
import {ShortMatriceDto} from "../../../_models/matrice.dtos";
import {ShortTypeAnalyseDto} from "../../../_models/type.analyse.dtos";
import {ShortParametreDto} from "../../../_models/parametre-dtos";
import {SampleStatusService} from "../../../../services/sample-status-service/sample.status.service";
import {MatriceService} from "../../../../services/matrice-service/matrice.service";
import {TypeAnalyseService} from "../../../../services/type-analyse-service/type.analyse.service";
import {ParametreService} from "../../../../services/parametre-service/parametre.service";
import {SampleAnalyseResponseDto, SampleService} from "../../../../services/sample-service/sample.service";
import {HandleErrorsService} from "../../../../services/handle-erros/handle.errors.service";
import {ClientsService} from "../../../../services/client-service/clients.service";
import {MatDatepicker, MatDatepickerInput, MatDatepickerToggle} from "@angular/material/datepicker";
import {MatNativeDateModule} from "@angular/material/core";
import {MatCheckbox, MatCheckboxChange} from "@angular/material/checkbox";
import {AnalyseService} from "../../../../services/analyse-service/analyse.service";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {CookieService} from "ngx-cookie-service";
import {MatTab, MatTabGroup} from "@angular/material/tabs";
import { filter } from 'rxjs/operators';

import {
    MatAccordion, MatExpansionModule,
    MatExpansionPanel,
    MatExpansionPanelDescription,
    MatExpansionPanelTitle
} from "@angular/material/expansion";
import * as XLSX from 'xlsx';
import {TerrrainService} from "../../../../services/terrains-service/terrrain.service";
import {TerrainDTO} from "../../../_models/terrain.dto";
import { ProductData, typeSampleDTO } from '../../../_models/typeSampleDTO';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { SubstanceDTO } from '../../../_models/SubstanceDTO';
import { DevisService } from '../../../../services/devis-service/devis.service';
import { LotDto } from '../../../_models/LotDto';
import { LotService } from '../../../../services/lot-service/lot.service';
import { ParameterDTO } from '../../../_models/ParameterDTO';
import { NotificationApiService } from '../../../_services/notification.api.service';
import { interval } from 'rxjs';
import { startWith, takeWhile } from 'rxjs/operators';
import { ShortUserDTO } from '../../../_models/user.dtos';
import { UserService } from '../../../../services/user-service/user.service';
import { map } from 'rxjs/operators';
import { AppUserDTO } from '../../../_models/userDTO';
import { FichePaillasseService } from '../../../../services/fiche-paillasse-service/fiche-paillasse.service';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-sampler-list',
    standalone: true,
    providers: [TerrrainService,AnalyseService, ParametreService, TypeAnalyseService, ApiService, Endpoints, DialogService, MatriceService, SampleService, HandleErrorsService, ClientsService, SampleStatusService],
    imports: [MatExpansionModule,
        MatNativeDateModule,
        CommonModule,FormsModule,
MatAutocompleteModule,

        MatCardModule, MatMenuModule, MatButtonModule, RouterLink, MatTableModule, MatPaginatorModule, NgIf,
        MatTooltipModule, ReactiveFormsModule, MatFormField, MatLabel, MatError, MatInput,MatChipsModule,
        MatSuffix, MatSortModule, MatInputModule, MatOption,MatIconModule, MatSelect, MatDatepickerToggle, MatDatepicker, MatDatepickerInput, MatCheckbox, MatProgressSpinner, MatTab, MatTabGroup, MatAccordion, MatExpansionPanel, MatExpansionPanelTitle, MatExpansionPanelDescription
    ],
    templateUrl: './sampler-list.component.html',
    styleUrl: './sampler-list.component.scss'
})
export class SamplerListComponent implements OnInit, OnChanges, AfterViewInit {
    @ViewChild(MatPaginator) paginator: MatPaginator;
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild('editModal') editModal: TemplateRef<any>;
    @ViewChild('viewModal') viewModal: TemplateRef<any>;
    @ViewChild('content') content: TemplateRef<any>;  // Définir le ng-template comme @ViewChild

    form: FormGroup;
    formU: FormGroup;
    searchVal: string = ''
    statusList: SampleStatusDto[] = []
    clientList: ShortClientDto[] = []
    typeStList:typeSampleDTO[] = []
    matriceList: ShortMatriceDto[] = []
    typeAnalyseList: ShortTypeAnalyseDto[] = []
    paramList: ParameterDTO[] = []
    terrainList : TerrainDTO[];
    filteredTerrains: TerrainDTO[] = []; 
    lotList : LotDto[];
    selectedSampl: Set<SampleAnalyseResponseDto> = new Set<SampleAnalyseResponseDto>();
    dataSource1: MatTableDataSource<SampleAnalyseResponseDto> = new MatTableDataSource<SampleAnalyseResponseDto>();
    dataSource: MatTableDataSource<SampleDTO> = new MatTableDataSource<SampleDTO>();
    selectedSamples: Set<SampleDTO> = new Set<SampleDTO>();

    isAllSamplesSelected: boolean = false



    sample: any; // ou mieux, donne-lui un type précis si possible

    loadingTable: boolean = true;
    loadingOT: boolean = false
    loadingPdfGen: boolean = false
    loadingRapport: boolean = false
    loadingDevis: boolean = false

    loadingExcel: boolean = false
    panelOpenState = false;
    selectedLotName: string;
    selectedClientId: number | null = null;
    trackById(index: number, item: any): number {
        return item.id;
    }
    sampleTypeControl = new FormControl<string>('');  // Typage string pour valeur de l'input
    productList: ProductData[] = [];
    filteredProducts: ProductData[] = [];
    autocompleteActivated = false;

    userRoles: string[] = [];
    displayedColumns: string[] = [
    // 1️⃣ Infos générales
    'sampleCode',
    ...(this.hasNotRole('ROLE_SAMPLERS') ? ['socialReason'] : []),
    'referenceInterne', 
    'matriceName',
    'codeAT',
    'methode',
    'terrainVarPlante',
    'conditionnement',
    'conditionnementReception',
    // 2️⃣ Infos liées au lot et type
    'batchId',
    'sampleType',
    'withOt',
    'collectedById',
     'collectionDate',
    ...(this.hasNotRole('ROLE_PRELEVEUR') ? ['dateReception'] : []),
    'qtePre',
    'priorite',
    'volume',
    'scelle',
    'temperaturePrelevement',  
    'temperatureReception',   
    'departementName',
    'location',
    'nameCreatedBy',
    'sampStatus',
    'dureeRespectee',
    'dateProduction',          
    'dateLimiteConsommation',   
    'volumeSuffisant',
    'etiquetageLisible',
    'scelleIntact',
    'propreteContamination'
    ];

columnLabels: Record<string, string> = {
  sampleCode: 'Code échantillon',
  socialReason: 'Client',
  referenceInterne: 'Référence interne',
  matriceName: 'Matrice',
  codeAT: 'Type analyse',
  methode: 'Méthode',
  terrainVarPlante: 'Terrain',
  conditionnement: 'Conditionnement',
  conditionnementReception: 'Conditionnement réception',
  batchId: 'Lot',
  sampleType: 'Type échantillon',
  withOt: 'Statut OT',
  collectedById: 'Collecté par',
  collectionDate: 'Date de collecte',
  dateReception: 'Date de réception',
  qtePre: 'Quantité prélevée',
  priorite: 'Priorité',
  volume: 'Volume',
  scelle: 'Scellé',
  temperaturePrelevement: 'Température prélèvement',
  temperatureReception: 'Température réception',
  departementName: 'Département',
  location: 'Localisation',
  nameCreatedBy: 'Créé par',
  sampStatus: 'Statut',
  dureeRespectee: 'Délai respecté',
  dateProduction: 'Date de production',
  dateLimiteConsommation: 'DLC',
  volumeSuffisant: 'Volume suffisant',
  etiquetageLisible: 'Étiquetage lisible',
  scelleIntact: 'Scellé intact',
  propreteContamination: 'Propreté / contamination',
};
    ngOnInit() {
        this.fetchSampleList()
        this.fetchUsers();
        this.initializeCreateForm()
        this.fetchProducts();
        this.loadPreleveurs();
        try {
            const roles = sessionStorage.getItem('user_roles');
          
            if (roles?.startsWith('[')) {
              // Cas normal JSON : ["ROLE_ADMIN", "ROLE_SAMPLERS"]
              this.userRoles = JSON.parse(roles);
            } else if (roles) {
              // Cas chaîne unique avec espaces : "ROLE_ADMIN ROLE_SAMPLERS"
              this.userRoles = roles.split(' ');
            } else {
              this.userRoles = [];
            }
          
            console.log('📦 Rôles utilisateur chargés :', this.userRoles);
          } catch (error) {
            console.error('❌ Erreur de parsing des rôles :', error);
            this.userRoles = [];
          }
          
        this.sampleTypeControl.valueChanges
            .pipe(
            filter(() => this.autocompleteActivated),
            map(value => typeof value === 'string' ? value : ''),
            map(value => value ? this.filterProducts(value) : this.productList)
            )
            .subscribe(filtered => {
            this.filteredProducts = filtered;
            console.log('Produits filtrés :', filtered);
            });

            this.displayedColumns = [
                'sampleCode',
                ...(this.hasNotRole('ROLE_SAMPLERS') ? ['socialReason'] : []),
                'referenceInterne', 
                'matriceName',
                'codeAT',
                'methode',
                'batchId',
                'terrainVarPlante',
                'sampleType',
                'withOt',
                'collectedById',
                'collectionDate',
                ...(this.hasNotRole('ROLE_PRELEVEUR') ? ['dateReception'] : []),
                'qtePre',
                'priorite',
                'volume',
                'scelle',
                'conditionnement',
                'conditionnementReception',
                'temperaturePrelevement', 
                'temperatureReception',  
                'departementName',
                'dateProduction',          
                'dateLimiteConsommation',  
                'dureeRespectee',
                'scelleIntact',
                'volumeSuffisant',
                'propreteContamination',
                'etiquetageLisible'
                        ];
        this.getColsCookie()
        this.fetchStatusList()
        this.fetchClientList()
        this.fetchMatriceList()
        this.fetchLotList()

        this.fetchTypeSampletList()
        this.lotService.openSampleModal$.subscribe(batchId => {
            console.log('📦 ID du lot reçu :', batchId);
          
            interval(300)
              .pipe(takeWhile(() => !this.lotList || this.lotList.length === 0, true))
              .subscribe(() => {
                if (this.lotList && this.lotList.length > 0) {
                  const selectedLot = this.lotList.find(lot => lot.id === batchId);
                  if (selectedLot) {
                    const client = this.clientList?.find(cl => cl.id === selectedLot.clientId);
                    const clientName = client ? client.identification : 'Client non trouvé';
          
                    this.selectedClientName = clientName;
                    this.selectedClientId = selectedLot.clientId;
                    this.selectedLotName = selectedLot.batchName;
                    this.selectedLotId = selectedLot.id;
          
                    this.fetchTerrainList(this.selectedClientId);
                    this.form.get('batchId')?.setValue(selectedLot.id, { emitEvent: false });
                    this.form.get('clientId')?.setValue(selectedLot.clientId, { emitEvent: false });
          
                    this.form.get('batchId')?.disable();
                    this.form.get('clientId')?.disable();
          
                    console.log('selectedClientId:', this.selectedClientId);
                    console.log('form.get("clientId")?.value:', this.form.get('clientId')?.value);
                    console.log('✅ Lot et client récupérés. Ouverture du modal.');
          
                    this.openModal(this.content);
                  } else {
                    console.warn('❌ Lot introuvable dans la liste.');
                  }
                }
              });
          });
          
          this.form.get('batchId')?.valueChanges.subscribe(batchId => {
            // Ignore si les valeurs viennent d’un patch depuis le modal
            if (!this.form.get('batchId')?.enabled) return;
          
            if (batchId) {
              const selectedLot = this.lotList?.find(lot => lot.id === batchId);
              if (selectedLot) {
                const client = this.clientList?.find(cl => cl.id === selectedLot.clientId);
                const clientName = client ? client.identification : 'Client non trouvé';
          
                this.form.patchValue({
                  clientId: selectedLot.clientId
                });
          
                this.form.get('clientId')?.disable();
                this.selectedClientId = selectedLot.clientId;
                this.fetchTerrainList(this.selectedClientId);

                this.selectedLotId = selectedLot.id;
          
                console.log('🎯 Client auto-rempli pour le lot :', clientName);
              }
            } else {
              this.selectedClientId = null;
              this.selectedLotId = null;
            }
          });

    }
    columns: string[] = [...this.displayedColumns];


    hasPesticideSample(): boolean {
        console.log('🔍 Vérification des échantillons sélectionnés pour type PESTICIDE...');
        const samplesArray = Array.from(this.selectedSamples);
      
        if (samplesArray.length === 0) {
          console.log('⚠️ Aucun échantillon sélectionné.');
          return false;
        }
      
        for (const sample of samplesArray) {
          console.log(`🧪 Sample ID: ${sample.id}, codeAT: ${sample.codeAT}`);
        }
      
        const hasPesticide = samplesArray.some(sample => sample.codeAT === 'PESTICIDE');
      
        console.log(`✅ Résultat : ${hasPesticide ? 'au moins un échantillon est de type PESTICIDE' : 'aucun échantillon de type PESTICIDE'}`);
      
        return hasPesticide;
      }
      
    preleveurs: AppUserDTO[] = [];

loadPreleveurs() {
  this.userService.getUsers().subscribe({
    next: (res) => {
      if (res.status) {
        // Filtrer uniquement les utilisateurs qui ont le rôle "ROLE_PRELEVEUR"
        this.preleveurs = res.data.filter((user: { roles: string | string[] }) => {
          const roles = Array.isArray(user.roles) ? user.roles : [user.roles];
          return roles.includes('ROLE_PRELEVEUR');
        });
        console.log('✅ Liste des préleveurs chargée :', this.preleveurs);
      } else {
        console.error('Erreur lors de la récupération des utilisateurs. Statut:', res.status);
      }
    },
    error: (err) => {
      console.error('Erreur chargement préleveurs', err);
    }
  });
}

fetchProducts() {
  this.sampleService.getAllProducts().subscribe({
    next: (products) => {
      console.log('Produits récupérés avec succès :', products);

      this.productList = products;
      this.filteredProducts = [];
    },
    error: (err) => {
      console.error('Erreur lors du chargement des produits', err);
    }
  });
}
getProductName(id: number): string {
    if (!this.productList || !id) return 'Inconnu';
    const product = this.productList.find(p => p.id === id);
    return product ? product.productName : 'Inconnu'; // ou typeSampleName selon ton DTO
}

hasRole(role: string): boolean {
    const has = Array.isArray(this.userRoles) && this.userRoles.includes(role);
    return has;
  }
  
  hasNotRole(role: string): boolean {
    const notHas = !this.hasRole(role);
    return notHas;
  }
  
  
displayProductName(productId: any): string {
  if (!productId) return '';
  const product = this.filteredProducts.find(p => p.productId === productId);
  return product ? product.productName : '';
}

filterProducts(value: string): ProductData[] {
  const filterValue = value.toLowerCase();
  return this.productList.filter(product =>
    product.productName.toLowerCase().includes(filterValue)
  );
}

onInputFocus() {
  this.autocompleteActivated = true;
    console.log("Champ focus, activation de l'autocomplete");

}

onProductSelected(event: any) {
  const selectedProduct = this.productList.find(p => p.productName === event.option.value);
  if (selectedProduct) {
    this.form.get('sampleType')?.setValue(selectedProduct.id);  // mets l'ID dans le formulaire
    this.sampleTypeControl.setValue(selectedProduct.productName, { emitEvent: false }); // affiche le nom
  }
}

    createAnotherSample() {
        const currentBatchId = this.form.get('batchId')?.value;
        
        this.form.reset();
        this.paramList = []; // Vide explicitement la liste des paramètres
        
        // Réinitialise les champs spécifiques (matrice et type d'analyse)
        this.form.patchValue({
            batchId: currentBatchId,
            matriceId: null,
            idAT: null
        });
        
        // Désactive le champ batchId
        this.form.get('batchId')?.disable();
        
        // Ferme la modale
        this.modalService.dismissAll();
        
        setTimeout(() => {
            this.fetchParametres();  
            this.fetchTypeAnalyseList(); 
            this.lotService.requestOpenSampleModal(currentBatchId);
        }, 300);
    }
    
      

    constructor(
        private route: ActivatedRoute,
        private terrainService : TerrrainService,
        private cookieService: CookieService,
        private apiService: ApiService,
        private fichePaillasseService: FichePaillasseService,
        private endpoints: Endpoints,
        private spinner: NgxSpinnerService,
        private dialogService: DialogService,
        private analyseService: AnalyseService,
        private fb: FormBuilder,
        private modalService: NgbModal,
        public themeService: CustomizerSettingsService,
        private cdr: ChangeDetectorRef,
        private overlayContainer: OverlayContainer,
        private matriceService: MatriceService,
        private notificationApiService: NotificationApiService,
        private sampleService: SampleService,
        private lotService:LotService,
        private userService:UserService,
        private handleErrors: HandleErrorsService,
        private clientService: ClientsService,
        private sampleStatusSerive: SampleStatusService,
        private typeAnalyseService: TypeAnalyseService,
        private parametreService: ParametreService) {
        this.initializeForm();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['dataSource']) {
            this.initializeForm();
        }
    }

getSampleTypeName(id: number): string {
  const type = this.productList.find(t => t.id === id);
  if (type) {
    return type.productName;
  } else {
    return 'Inconnu';
  }
}

    ngAfterViewInit() {
        this.initializePaginatorAndSort()
    }

    trackByFn(index: number, item: any): number {
        return item.id;
    }
    
    initializePaginatorAndSort() {
        this.overlayContainer.getContainerElement().style.zIndex = '2000';
        this.dataSource1.filter = this.searchVal
        this.dataSource1.paginator = this.paginator;
        this.dataSource1.sort = this.sort;
        this.sort.active = 'id';
        this.sort.direction = 'desc';

    }

fetchTerrainList(clientId: number) {
  this.terrainService.findAll().subscribe({
    next: response => {
      if (response.status) {
        this.terrainList = response.data;
        console.log('✅ Tous les terrains récupérés :', this.terrainList);

        this.filteredTerrains = this.terrainList.filter(
          t => Number(t.clientId) === Number(clientId)
        );

        console.log('🎯 Terrains filtrés pour clientId', clientId, ':', this.filteredTerrains);
      }
    },
    error: err => {
      console.error('❌ Erreur lors du chargement des terrains :', err);
    }
  });
}


    fetchLotList(){
        this.lotService.getAllBatches().subscribe({
            next : response => {
                if (response){
                    this.lotList = response
                    console.log(this.lotList);
                }
            }
        })
    }
    initializeForm() {
     this.form = this.fb.group({
    id: [''],
    sampleCode: [''],
    sampleType: ['', Validators.required],
    collectedById: ['', Validators.required],
    collectedByName: [''], // <- ajouté
    collectionDate: ['', Validators.required],
    dateReception: ['', Validators.required],
    qtePre: [0, Validators.required],
    priorite: [0, [Validators.required, Validators.min(1), Validators.max(3)]],
    volume: ['', Validators.required],
    temperaturePrelevement: [''],   // nouveau
    temperatureReception: [''], 
    departementName: [''], 
    volumeSuffisant: [''],
    etiquetageLisible : [''],   // nouveau
    dateProduction: [''],           // nouveau
    dateLimiteConsommation: [''],   // nouveau
    referenceInterne: [''],         // nouveau
    visa: [''],                      // nouveau
    comments: [''],
    location: [''],
    creationDate: [''],
    updateDate: [''],
    methode: ['', Validators.required],
    idCreatedBy: [''],
    clientId: ['', Validators.required],
    socialReason: [''],
    matriceName: [''],
    nameCreatedBy: [''],
    status: [0],
    sampStatus: [null, Validators.required],
    note: [''],
    matriceId: [null, Validators.required],
    batchId: [null],
    codeAT: [''],
    idAT: [null, Validators.required],
    parametreId: [null],
    terrainId: [null],
    terrainName: [null]
});



        this.sampleTypeControl = this.form.get('sampleType') as FormControl;

    }

    openEditModal(element: any) {
        console.log("element:",element)
        this.fetchTypeAnalyseList(element.matriceId);        
        this.fetchParametres(element.idAT)
        this.form.patchValue(element);
        this.cdr.detectChanges(); // Force la détection des changements
        this.modalService.open(this.editModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }

    openViewModel(sample: SampleDTO) {
        console.log("📦 Sample ouvert dans le modal :", sample); // <-- Log ajouté
        this.fetchParametres(sample.idAT!)
        this.form.patchValue(sample);
        this.cdr.detectChanges();
        this.modalService.open(this.viewModal, {ariaLabelledBy: 'modal-basic-title', size: 'xl'});
    }


    lots: any[] = [];
    terrains: any[] = [];

    lotSelected = false;
    selectedClientName = "";
    selectedTerrainName = "";
    // Quand un LOT est sélectionné
onLotChange(lotId: number | null) {
  console.log("📌 onLotChange déclenché, lotId:", lotId);

  if (!lotId) {
    // Pas de lot → sélection libre
    console.log("⚡ Aucun lot sélectionné → mode manuel pour Client et Terrain");
    this.lotSelected = false;
    this.form.get('clientId')?.enable();
    this.form.get('terrainId')?.enable();
    this.selectedClientName = '';
    this.selectedTerrainName = '';
    this.form.patchValue({ clientId: null, terrainId: null });
    this.filteredTerrains = [];
    console.log("Form après reset:", this.form.getRawValue());
    return;
  }

  // Lot choisi → remplir client et terrain
  this.lotSelected = true;
  const lot = this.lotList.find(l => l.id === lotId);
  if (!lot) {
    console.warn("⚠️ Lot non trouvé dans lotList pour id:", lotId);
    return;
  }

  console.log("✅ Lot trouvé:", lot);

  // Récupérer le client depuis clientList
  const client = this.clientList.find(c => c.id === lot.clientId);
  if (!client) {
    console.warn("⚠️ Client non trouvé pour clientId:", lot.clientId);
    this.selectedClientName = 'Client non trouvé';
  } else {
    this.selectedClientName = client.identification; // ou client.socialReason selon ce que tu veux afficher
  }
  console.log("Client associé au lot:", this.selectedClientName, "clientId:", lot.clientId);

  // Charger et filtrer les terrains pour ce client
  this.fetchTerrainList(lot.clientId);

  this.form.patchValue({
    clientId: lot.clientId,
    batchId: lot.id
  });

  // Désactiver modification
  this.form.get('clientId')?.disable();
  this.form.get('terrainId')?.disable();

  console.log("Form après patch:", this.form.getRawValue());
  console.log("Champs clientId et terrainId désactivés");
}


onClientChange(clientId: number | null) {
  console.log("📌 onClientChange déclenché, clientId:", clientId);

  if (!clientId) {
    console.log("⚡ Aucun client sélectionné → reset terrains");
    this.filteredTerrains = [];
    this.selectedTerrainName = '';
    this.form.patchValue({ terrainId: null });
    return;
  }

  // Charger les terrains
  this.fetchTerrainList(clientId);

  // Laisser la sélection libre, pas de sélection automatique
  this.form.patchValue({ terrainId: null });
  this.selectedTerrainName = '';
}

    updateTableRow(updatedData: any) {
        const index = this.dataSource.data.findIndex((item: { id: any; }) => item.id === updatedData.id);
        if (index !== -1) {
            this.dataSource.data[index] = updatedData;
        }
    }

    confirmDelete(element: any) {
        this.dialogService.open("Êtes-vous sûr de vouloir supprimer cet échantillon ?", environment.warning_message_type, 'danger', environment.warning_icon, true)
            .then((result: any) => {
                if (result) {
                    this.deleteSampler(element.id);
                }
            });
    }
    userList: ShortUserDTO[] = []
    fetchUsers() {
        this.userService.getUsers().subscribe({
            next: res => {
                console.log("Réponse reçue:", res);  // Log de la réponse reçue
    
                if (res.status) {
                    this.userList = res.data.filter((user: { roles: string | string[]; }) => user.roles.includes('ROLE_SAMPLERS'));
                } else {
                    console.log("Erreur lors de la récupération des utilisateurs. Statut:", res.status);
                }
            },
            error: err => {
                console.error("Erreur lors de l'appel du service:", err);
            }
        });
    }
    
    selectedElements: Set<number> = new Set<number>()
    selectedAll: boolean = false
    initializeCreateForm() {
        this.formU = this.fb.group({
            userId: ['', Validators.required] 
        });
    }
    affectUser(): void {

    const userId = this.formU.value.userId;

    console.log('🔹 User ID sélectionné :', userId);

    if (!userId) {
        console.log('❌ userId est vide');

        this.dialogService.open(
            'Veuillez sélectionner un préleveur.',
            environment.error_message_type,
            'danger',
            environment.error_icon
        );

        return;
    }

    // Vérifier les IDs sélectionnés
    if (this.selectedSamplIds.size === 0) {

        console.log('❌ Aucun échantillon sélectionné');
        console.log(
            'selectedSamplIds :',
            this.selectedSamplIds
        );

        this.dialogService.open(
            'Veuillez sélectionner au moins un échantillon à affecter.',
            environment.error_message_type,
            'danger',
            environment.error_icon
        );

        return;
    }

    if (!this.formU.valid) {

        console.log('❌ Formulaire invalide');

        this.dialogService.open(
            'Veuillez vérifier les champs du formulaire.',
            environment.error_message_type,
            'danger',
            environment.error_icon
        );

        return;
    }

    // Récupération des IDs
    const ids: number[] = [...this.selectedSamplIds];

    console.log(
        '📊 IDs des échantillons sélectionnés :',
        ids
    );

    // Suppression des doublons
    const uniqueIds = [...new Set(ids)];

    console.log(
        '📊 IDs uniques envoyés au backend :',
        uniqueIds
    );

    // Création de la requête
    const request: SampleAffectationRequest = {
        userId: userId,
        sampleIds: uniqueIds
    };

    console.log(
        '📤 Données envoyées au backend :',
        request
    );

    // Appel backend
    this.sampleService
        .affectUserToSamples(request)
        .subscribe({

            next: response => {

                console.log(
                    '📥 Réponse du backend :',
                    response
                );

                if (response.status) {

                    this.fetchSampleList();

                    this.modalService.dismissAll();

                    this.updateTableRow(response);

                    this.dialogService.openSuccessDialog(
                        response.message
                    );

                    this.selectedAll = false;

                    // Nettoyage de la sélection
                    this.selectedSamplIds.clear();

                    console.log(
                        '✅ Sélection nettoyée'
                    );

                } else {

                    this.dialogService.open(
                        response.message ||
                        'Erreur lors de l\'affectation.',
                        environment.error_message_type,
                        'danger',
                        environment.error_icon
                    );
                }
            },

            error: error => {

                console.error(
                    '❌ Erreur lors de l’affectation :',
                    error
                );

                let backendMessage =
                    error?.error?.message;

                if (typeof backendMessage === 'string') {

                    try {

                        const parsed =
                            JSON.parse(backendMessage);

                        backendMessage =
                            parsed?.message ||
                            backendMessage;

                    } catch (e) {

                        console.log(
                            'Message non JSON'
                        );
                    }
                }

                const message =
                    backendMessage ||
                    'Une erreur est survenue lors de l’affectation.';

                this.dialogService.openDangerAlert(
                    message
                );
            },

            complete: () => {

                this.formU.reset();

                console.log(
                    '✅ Affectation terminée'
                );
            }
        });
}

printSample() {
  console.log('🔹 Début printSample');

  // 🔹 Construire selectedSampl à partir de selectedSamplIds
  this.selectedSampl = new Set(
    this.dataSource1.filteredData.filter(s => this.selectedSamplIds.has(s.sampleAnalyseId))
  );

  console.log('📦 Nombre d\'échantillons sélectionnés :', this.selectedSampl.size);

  if (this.selectedSampl.size < 1) {
    this.dialogService.openDangerDialog('Aucun échantillon sélectionné');
    console.log('❌ Aucun échantillon sélectionné, sortie de la fonction');
    return;
  }

  const conformes = Array.from(this.selectedSampl).filter(s => s.status !== 'NON_CONFORME');
  const nonConformes = Array.from(this.selectedSampl).filter(s => s.status === 'NON_CONFORME');

  console.log('✅ Échantillons conformes :', conformes.length);
  console.log('⚠️ Échantillons non conformes ignorés :', nonConformes.length);

  if (nonConformes.length > 0) {
    this.dialogService.openDangerDialog(
      `${nonConformes.length} échantillon(s) non conforme(s) ont été ignoré(s) lors de la génération des codes-barres.`
    );
  }

  if (conformes.length === 0) {
    console.log('❌ Aucun échantillon conforme, sortie de la fonction');
    return;
  }

  this.loadingPdfGen = true;
  console.log('⏳ Génération du PDF en cours...');

  setTimeout(() => {
    try {
      const doc = new pdfGenerator.jsPDF();
      let y: number = 20;
      const pageHeight = doc.internal.pageSize.height;

      for (let i = 0; i < conformes.length; i++) {
        const sample = conformes[i];
        console.log(`🔹 [${i + 1}/${conformes.length}] Génération du code-barre pour SampleAnalyse ID: ${sample.sampleAnalyseId}, SampleCode: ${sample.sampleCode}`);

        if (!sample.sampleCode) {
          console.warn(`⚠️ SampleAnalyse ID=${sample.sampleAnalyseId} n'a pas de sampleCode, code-barre ignoré`);
          continue;
        }

        const canvas = document.createElement('canvas');
        try {
          JsBarcode(canvas, sample.sampleCode, { format: 'CODE39' });
        } catch (err) {
          console.error(`❌ Erreur JsBarcode pour SampleAnalyse ID=${sample.sampleAnalyseId}:`, err);
          continue;
        }

        const imgData = canvas.toDataURL('image/png');

        if (y + 40 > pageHeight) {
          doc.addPage();
          console.log('➕ Nouvelle page ajoutée dans le PDF');
          y = 10;
        }

        let formattedDate = 'Date non définie';
        if (sample.collectionDate) {
          try {
            formattedDate = new Date(sample.collectionDate).toLocaleDateString('fr-FR', {
              year: 'numeric',
              month: 'short',
              day: 'numeric'
            });
          } catch (err) {
            console.warn(`⚠️ Impossible de formater collectionDate pour SampleAnalyse ID=${sample.sampleAnalyseId}:`, sample.collectionDate, err);
          }
        }

        try {
          doc.text(`iLab ${formattedDate}`, 50, y);
          doc.addImage(imgData, 'PNG', 50, y + 1, 100, 30);
          console.log(`✔ Code-barre ajouté pour SampleAnalyse ID=${sample.sampleAnalyseId}`);
        } catch (err) {
          console.error(`❌ Erreur ajout texte/image PDF pour SampleAnalyse ID=${sample.sampleAnalyseId}:`, err);
        }

        y += 40;
      }

     // 🔹 Préparer les codes des échantillons conformes pour le nom du fichier
    const sampleCodesForFilename = conformes
    .map(s => s.sampleCode?.replace(/[\/\\:?*"<>| ]/g, '_')) // remplacer les caractères interdits dans le nom de fichier
    .join('-');

    const filename = `samples_code_barre_${sampleCodesForFilename}.pdf`;

      doc.save(filename);
      console.log('💾 PDF sauvegardé :', filename);

    } catch (err) {
      console.error('❌ Erreur fatale lors de la génération du PDF:', err);
    } finally {
      this.loadingPdfGen = false;
      this.isAllSamplesSelected = false;
      this.selectedSampl = new Set<SampleAnalyseResponseDto>();
      console.log('✅ Fin printSample, sélection réinitialisée');
    }

  }, 3000);
}

      
deleteSampler(id: number) {
    this.apiService.delete(id, this.endpoints.sampler_base_endpoint + '/delete_sample').pipe(
        tap((response: any) => {
            console.log('Réponse de suppression :', response); // ✅ Console ajoutée

            if (response.status) {
                this.removeTableRow(id);
                this.dialogService.openSuceessAlert('Échantillon supprimé avec succès');
            } else {
                this.dialogService.openDangerAlert(response.message || 'Suppression échouée');
            }
        }),
        finalize(() => {
            this.dataSource1.paginator = this.paginator;
        })
    ).subscribe({
        error: (err) => {
            console.error('Erreur lors de la suppression :', err); // ✅ Console ajoutée
            this.dialogService.openDangerAlert(err.error.message || 'Erreur serveur');
        }
    });
}

    
    removeTableRow(id: number) {
        this.dataSource.data = this.dataSource.data.filter((sample: { id: number; }) => sample.id !== id);
        this.dataSource = new MatTableDataSource<any>(this.dataSource.data);
    }

    applyFilter(event: Event) {
        this.searchVal = (event.target as HTMLInputElement).value.trim().toLowerCase();
        this.dataSource1.filter = this.searchVal
    }

    selectedSamplIds: Set<number> = new Set<number>();

handleSelection(sam: SampleAnalyseResponseDto) {

    console.log("========================================");
    console.log("🟡 handleSelection appelé");
    console.log("📦 Objet :", sam);
    console.log("🆔 sampleAnalyseId :", sam?.sampleAnalyseId);

    console.log(
        "🔎 AVANT modification selectedSamplIds :",
        Array.from(this.selectedSamplIds)
    );

    console.log(
        "🔎 Est-ce que l'ID existe déjà ? :",
        this.selectedSamplIds.has(sam?.sampleAnalyseId)
    );

    const id = sam?.sampleAnalyseId;

    if (!id) {
        console.warn("⚠️ sampleAnalyseId manquant");
        return;
    }

    if (this.selectedSamplIds.has(id)) {

        console.log(`🔴 ID ${id} existe déjà → SUPPRESSION`);

        this.selectedSamplIds.delete(id);

        const existing = Array.from(this.selectedSampl).find(
            (item: SampleAnalyseResponseDto) =>
                item.sampleAnalyseId === id
        );

        if (existing) {
            this.selectedSampl.delete(existing);
        }

    } else {

        console.log(`🟢 ID ${id} n'existe pas → AJOUT`);

        this.selectedSamplIds.add(id);
        this.selectedSampl.add(sam);

    }

    console.log(
        "📊 APRÈS selectedSamplIds :",
        Array.from(this.selectedSamplIds)
    );

    console.log(
        "📦 APRÈS selectedSampl :",
        Array.from(this.selectedSampl)
    );

    console.log("========================================");
}

handleSelectAll() {
    this.isAllSamplesSelected = !this.isAllSamplesSelected;
    console.log("🟡 handleSelectAll appelé, nouvel état isAllSamplesSelected :", this.isAllSamplesSelected);

    if (this.isAllSamplesSelected) {
        this.selectedSamplIds = new Set<number>(
            this.dataSource1.filteredData
                .map(s => s.sampleAnalyseId)
                .filter(id => id != null)
        );
        console.log("🔹 Tous les sampleAnalyseId ajoutés à la sélection :", Array.from(this.selectedSamplIds));
    } else {
        this.selectedSamplIds.clear();
        console.log("🔹 Sélection vidée");
    }

    console.log("📊 État final de selectedSamplIds :", Array.from(this.selectedSamplIds));
    console.log("   ➜ Nombre total sélectionné :", this.selectedSamplIds.size);
}



    modalContentType: string = '';
    openAssignUserModal(content: any): void {
        console.log('Ouverture du modal d\'affectation utilisateur');
        
        // Réinitialisation des variables ou état nécessaire
        this.form.reset();  // Réinitialisation du formulaire
    
        // Ouverture du modal avec contenu spécifique à l'affectation
        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', size: 'lg' }).result.then(
            (result) => {
                console.log('Résultat du modal :', result);
                if (result === 'save') {
                    console.log('Utilisateur affecté à l\'analyse');
                }
            }
        ).catch((error) => {
            console.error('Erreur lors de l\'ouverture du modal', error);
        });
    }

    openModal(content:any) {
        console.log('Tentative d\'ouverture du modal');
        this.form.reset();
        this.paramList=[];
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'xl'}).result.then(
            (result) => {
                console.log('Résultat du modal :', result);
                if (result === 'save') {
                    console.log('Formulaire sauvegardé');
                }
            }
        ).catch((error) => {
            console.error('Erreur lors de l\'ouverture du modal', error);
        });
    }
    openAffectationModal(content: any) {
        console.log('Tentative d\'ouverture du modal d\'affectation');
        this.formU.reset();  // Réinitialise le formulaire d'affectation
        this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title', size: 'lg'}).result.then(
            (result) => {
                console.log('Résultat du modal d\'affectation :', result);
                if (result === 'save') {
                    console.log('Affectation effectuée');
                }
            }
        ).catch((error) => {
            console.error('Erreur lors de l\'ouverture du modal d\'affectation', error);
        });
    }
    

    isSubmitting: boolean = false;
    selectedLotId: number | null = null; 
    getSampleCountForBatch(batchId: number): number {
        return this.dataSource.data.filter(sample => sample.batchId === batchId).length;
    }
    
    getRemainingSamples(batchId: number): number {
        const selectedLot = this.lotList?.find(lot => lot.id === batchId);
        const currentSampleCount = this.getSampleCountForBatch(batchId);
        const maxSamplesAllowed = selectedLot?.numberOfSamples || 0;
        return maxSamplesAllowed - currentSampleCount;
    }
updateSample() {
    if (this.form.valid) {
        const formValue = this.form.getRawValue();

        // Lot et terrain facultatifs → pas de vérification obligatoire
        formValue.batchId = formValue.batchId || null;
        formValue.terrainId = formValue.terrainId || null;

        // Vérification et assignation de clientId uniquement si nécessaire
        if (!formValue.clientId && this.selectedClientId) {
            formValue.clientId = this.selectedClientId;
        }

        // Formatage des dates
        if (formValue.collectionDate) {
            formValue.collectionDate = new Date(formValue.collectionDate).toISOString().replace('Z', '');
        }
        if (formValue.dateReception) {
            formValue.dateReception = new Date(formValue.dateReception).toISOString().replace('Z', '');
        }

        console.log('Objet envoyé au backend pour mise à jour :', formValue);

        this.isSubmitting = true;

        this.sampleService.updateSample(formValue.id, formValue).subscribe({
            next: res => {
                const index = this.dataSource.data.findIndex((sam: { id: number }) => sam.id === res.id);
                if (index !== -1) {
                    this.dataSource.data[index] = res;
                    this.dataSource._updateChangeSubscription();
                }

                this.modalService.dismissAll();
                this.dialogService.openSuceessAlert('Échantillon mis à jour avec succès');
            },
            error: err => {
                console.error('Erreur lors de la mise à jour de l\'échantillon:', err);
                const msg = err?.error?.message || 'L\'utilisateur n\'a pas l\'autorisation de modifier des échantillons.';
                this.dialogService.openDangerAlert(msg);
            },
            complete: () => {
                this.spinner.hide().finally();
                this.isSubmitting = false;
                this.initializePaginatorAndSort();
            }
        });

    } else {
        console.log('Formulaire invalide :', this.form.value);
        console.log('Erreurs de validation :');
        Object.keys(this.form.controls).forEach(key => {
            const control = this.form.get(key);
            if (control && control.invalid) {
                console.log(`- ${key} :`, control.errors);
            }
        });

        this.dialogService.openDangerAlert('Demande erronée. Veuillez vérifier votre saisie !');
    }
}

      
saveSample(createAnother = false) {
    if (this.form.valid) {
        const formValue = this.form.getRawValue(); 

        // Log de la valeur de SampStatus avant l'enregistrement
        console.log('Valeur de SampStatus avant enregistrement:', formValue.sampStatus);

        // Vérification que la note est obligatoire pour les échantillons "Non conforme"
        if (formValue.sampStatus === 'NON_CONFORME' && (!formValue.note || formValue.note.trim() === '')) {
            this.dialogService.open(
                'Le champ "Note" est obligatoire pour les échantillons Non Conformes.',
                environment.error_message_type,
                'danger',
                environment.error_icon
            ).finally();
            return;
        }

        // Vérification de l'ID du client
        if (!formValue.clientId && this.selectedClientId) {
            formValue.clientId = this.selectedClientId;
        }

        console.log('form.getRawValue().clientId:', formValue.clientId);

        // Gestion du lot (batch) optionnel
        let selectedLot;
        let maxSamplesAllowed = 0;
        let currentSampleCount = 0;

        if (formValue.batchId) {
            selectedLot = this.lotList?.find(lot => lot.id === formValue.batchId);
            maxSamplesAllowed = selectedLot?.numberOfSamples || 0;
            currentSampleCount = this.getSampleCountForBatch(formValue.batchId);

            if (currentSampleCount >= maxSamplesAllowed) {
                this.dialogService.open(
                    `Ce lot a déjà atteint le nombre maximal d’échantillons (${maxSamplesAllowed}) !`,
                    environment.error_message_type,
                    'warning',
                    environment.error_icon
                ).then(() => {
                    this.modalService.dismissAll();
                });
                return;
            }
        }

        // Gestion des dates
        if (formValue.collectionDate) {
            formValue.collectionDate = new Date(formValue.collectionDate).toISOString().replace('Z', '');
        }
        if (formValue.dateReception) {
            formValue.dateReception = new Date(formValue.dateReception).toISOString().replace('Z', '');
        }

        console.log('Objet envoyé au backend:', formValue);

        this.isSubmitting = true;

        this.sampleService.save(formValue).subscribe({
            next: res => {
                const index = this.dataSource.data.findIndex((sam: { id: number }) => sam.id === res.id);
                if (index !== -1) {
                    this.updateTableRow(res);
                } else {
                    this.dataSource.data = [...this.dataSource.data, res];
                }

                if (createAnother) {
                    let batchId = formValue.batchId;
                    let clientId = formValue.clientId;
                    let collectedById = formValue.collectedById;
                    let dateReception = formValue.dateReception;

                    this.form.reset();
                    this.form.patchValue({ batchId, clientId, collectedById, dateReception });

                    if (batchId) this.form.get('batchId')?.disable();
                    if (clientId) this.form.get('clientId')?.disable();

                } else {
                    this.modalService.dismissAll();
                }

                this.dialogService.openSuceessAlert('Échantillon enregistré avec succès');
            },
            error: err => {
                console.error('Erreur lors de l\'enregistrement de l\'échantillon:', err);
                const msg = err?.error?.message || 'L\'utilisateur n\'a pas l\'autorisation de modifier des échantillons.';
                this.dialogService.openDangerAlert(msg);
            },
            complete: () => {
                this.spinner.hide().finally();
                this.isSubmitting = false;
                this.initializePaginatorAndSort();
            }
        });

    } else {
        console.log('Formulaire invalide :', this.form.value);
        console.log('Erreurs de validation :');
        Object.keys(this.form.controls).forEach(key => {
            const control = this.form.get(key);
            if (control && control.invalid) {
                console.log(`- ${key} :`, control.errors);
            }
        });

        this.dialogService.open(
            'Demande erronée. Veuillez vérifier votre saisie!',
            environment.error_message_type,
            'danger',
            environment.error_icon
        ).finally();
    }
}
    getCollectedByName(id: number): string {
        const user = this.userList.find(u => u.id === id);
        return user ? user.username : 'Inconnu'; 
    }

    
  private fetchStatusList() {
        this.sampleStatusSerive.fetchSampleStatusList().subscribe(
            {next: response => this.statusList = response})}

    private fetchClientList() {
        this.clientService.loadClients().subscribe({
                next: response => response.status ? this.clientList = response.data : null,
            }
        );
    }

    getClientName(clientId: number): string {
        const client = this.clientList?.find(cl => cl.id === clientId);
        return client ? client.identification : '—';
    }
    productFilter: string = '';

filteredProductList(): ProductData[] {
  if (!this.productFilter) {
    return this.productList;
  }
  const filterValue = this.productFilter.toLowerCase();
  return this.productList.filter(product =>
    product.productName.toLowerCase().includes(filterValue) ||
    product.productCode?.toLowerCase().includes(filterValue)
  );
}


    private fetchTypeSampletList() {

          this.sampleService.getAllProducts().subscribe({
    next: (products) => {
      this.productList = products;
    },
    error: (err) => {
      console.error('Erreur lors du chargement des produits', err);
    }
  });
    }

 private fetchMatriceList() {
    console.log("=== fetchMatriceList appelé");
    
    this.matriceService.fetchmatriceList().subscribe({
        next: response => {
            console.log("Réponse complète matriceList:", response);
            console.log("response.status:", response.status);
            console.log("response.data:", response.data);
            
            if (response.status) {
                this.matriceList = response.data;
                console.log("✅ matriceList chargée:", this.matriceList);
                console.log("Nombre de matrices:", this.matriceList?.length);
            } else {
                console.warn("⚠️ response.status = false, matriceList non chargée");
            }
        },
        error: err => {
            console.error("❌ Erreur fetchMatriceList:", err);
        }
    });
}
    showDropdown = false;
    selectedCountryCode: string | null = null;
    

    toggleCountryDropdown(event: MouseEvent): void {
        event.stopPropagation();
        if (this.hasPesticideSample()) {
          this.showDropdown = !this.showDropdown;
          console.log('🔽 Type PESTICIDE détecté → Affichage de la liste des pays');
        } else {
          console.log('📄 Type NON-PESTICIDE → Génération directe du rapport');
          this.generateRapport(); // méthode à adapter
        }
      }
      
    // pour fermer quand on clique ailleurs
    @HostListener('document:click')
    closeDropdown(): void {
      this.showDropdown = false;
    }
    
    selectCountryAndGenerate(code: string): void {
      console.log('Pays sélectionné :', code); // Pour debug
      this.selectedCountryCode = code;
      this.showDropdown = false; // fermer la liste
      this.generateRapport();
    }
  public fetchSampleList() {
  this.loadingTable = true;

  this.sampleService.getValidateForConnectedUser().subscribe({
    next: (response: SampleAnalyseResponseDto[]) => {
      console.log('✅ Réponse reçue (analyses validées) :', response);

      // 📌 Directement un tableau → pas response.data
      this.dataSource1.data = response;

      this.loadingTable = false;
    },
    error: err => {
      console.error('❌ Erreur chargement analyses validées', err);
      this.handleErrors.catchError(err);
      this.loadingTable = false;
    }
  });
}

showRejected = false;

showRejectedSamples() {

    console.log("========== 🚀 showRejectedSamples START ==========");

    this.showRejected = true;
    console.log("📌 showRejected =", this.showRejected);

    console.log("📡 Calling backend with status =", SampleStatus.REJETE);

    this.sampleService.getSamplesByStatus(SampleStatus.REJETE)
        .subscribe({
            next: (data) => {

                console.log("✅ Response received from backend");
                console.log("📦 Raw data:", data);
                console.log("📊 Number of rejected samples:", data?.length);

                if (!data || data.length === 0) {
                    console.warn("⚠️ No rejected samples found!");
                }

                this.dataSource1.data = data;

                console.log("🗂 dataSource1 updated");
                console.log("📊 Current dataSource1:", this.dataSource1.data);

                console.log("========== ✅ showRejectedSamples END ==========");
            },
            error: (err) => {
                console.error("❌ ERROR while fetching rejected samples");
                console.error("Status:", err.status);
                console.error("Message:", err.message);
                console.error("Full error:", err);
            },
            complete: () => {
                console.log("📡 Request completed");
            }
        });
}

loadingFichePaillasse = false;
generateFichePaillasse() {

  console.group('🧪 Génération Fiches de Paillasse');

  if (this.selectedSamples.size === 0) {
    console.error('❌ Aucun sample sélectionné');
    this.dialogService.openDangerDialog('Aucun échantillon sélectionné');
    console.groupEnd();
    return;
  }

  const samplesArray = [...this.selectedSamples];

  console.log('📌 Samples sélectionnés :', samplesArray);

  // 🔒 Vérification métier
  const samplesInvalides = samplesArray.filter(s => !s.methodeId);

  if (samplesInvalides.length > 0) {
    console.error('❌ Samples sans méthode :', samplesInvalides);
    this.dialogService.openDangerDialog('Un ou plusieurs échantillons n’ont pas de méthode');
    console.groupEnd();
    return;
  }

  this.loadingFichePaillasse = true;

  // 🔁 Génération fiche pour chaque sample
  samplesArray.forEach(sample => {

    console.log('📤 Génération fiche pour sample :', {
      sampleId: sample.id,
      methodeId: sample.methodeId
    });

    this.fichePaillasseService
      .generateFiche(sample.id, sample.methodeId)
      .subscribe({
        next: res => {
          this.dialogService.openSuceessAlert('Fiche de paillasse enregistré avec succès');
          console.log(`✅ Fiche générée pour sample ${sample.sampleCode}`, res);
        },
        error: err => {
          console.error(`🔥 Erreur pour sample ${sample.sampleCode}`, err);
        }
      });
  });

  this.loadingFichePaillasse = false;
  console.groupEnd();
}



// Si tu veux revenir aux validés
showValidatedSamples() {
    console.log('==============================');
    console.log('📥 showValidatedSamples START');
    console.log('🔁 Mode:', 'VALIDATED');
    console.log('==============================');

    this.showRejected = false;


    this.sampleService.getValidateForConnectedUser()
        .subscribe({
            next: (data) => {
                console.log('✅ API SUCCESS');
                console.log('📦 Raw data received:', data);

                if (!data || data.length === 0) {
                    console.warn('⚠️ No validated samples returned!');
                } else {
                    console.log(`📊 Nombre de samples: ${data.length}`);

                    // عرض أول عنصر للتشخيص
                    console.log('🔎 First sample:', data[0]);

        
                }

                this.dataSource1.data = data;

                console.log('🧾 DataSource updated');
                console.log('==============================');
                console.log('✅ showValidatedSamples END');
                console.log('==============================');
            },

            error: (err) => {
                console.error('❌ API ERROR while loading validated samples');
                console.error('📛 Error object:', err);

                if (err.status) {
                    console.error('📡 HTTP Status:', err.status);
                }

                if (err.error) {
                    console.error('📄 Backend message:', err.error);
                }

                console.log('==============================');
            },

            complete: () => {
                console.log('🏁 Observable completed');
            }
        });
}


    fetchParametres(id?: number) {
        let typeAnalyseId: number = id ? id : this.form.value.idAT;
        let matriceId: number = this.form.value.matriceId;
    
        console.log("Fetching parameters for TypeAnalyse ID:", typeAnalyseId, "and Matrice ID:", matriceId);
        
        this.parametreService.fetchParametreList(typeAnalyseId).subscribe({
            next: response => {
                console.log("Response received:", response);
                if (response.status) {
                    this.paramList = response.data; // Met à jour paramList avec les nouveaux paramètres
                    console.log("Updated paramList:", this.paramList);
                }
            },
            error: err => {
                console.error("Error fetching parameters:", err);
                this.handleErrors.catchError(err);
            }
        });
    }
    

    fetchTypeAnalyseList(matriceId?: number) {
        this.paramList = []
        this.typeAnalyseService.fetchTypeAnalyseList(matriceId ? matriceId : this.form.value.matriceId).subscribe({
            next: responce => responce.status ? this.typeAnalyseList = responce.data : console.log(responce.message),
            error: err => this.handleErrors.catchError(err)
        })
    }

    getLotNom(lotId: number): string {
        const client = this.lotList?.find(c => c.id === lotId);
        return client ? client.batchName : '-';
    }
    
  
    handleIsAllColsSelected(event: MatCheckboxChange) {
        if (event.checked) {
            this.displayedColumns = [...this.columns]
        } else {
            this.displayedColumns = []
        }
        this.setColsCookie()
    }

    getdisplayedCol = (): string[] => {

    const result = ['select', ...this.displayedColumns, 'action'];

    return result;
    };

    // Handle individual checkbox changes
    onSelectionChange(column: string): void {
        if (this.displayedColumns.includes(column)) {
            this.displayedColumns = this.displayedColumns.filter(c => c !== column);
        } else {
            this.displayedColumns.push(column)
        }
        this.setColsCookie()
    }

    user_name = sessionStorage.getItem('user_name');

    private setColsCookie() {
        this.cookieService.set(`sampCol_${this.user_name}`, JSON.stringify(this.displayedColumns), {
            expires: 7,
            path: '/',
            secure: true
        });
    }

private getColsCookie() {
  const sampleCols = this.cookieService.get(`sampCol_${this.user_name}`);

  if (sampleCols) {
    const parsedCols = JSON.parse(sampleCols);

    const validColumns = [
      'sampleCode',
      'socialReason',
      'matriceName',
      'codeAT',
      'methode',
      'batchId',
      'terrainVarPlante',
      'sampleType',
      'withOt',
      'collectedById',
      'dateReception',
      'qtePre',
      'priorite',
      'volume',
      'scelle',
      'conditionnement',
      'conditionnementReception',
      'temperaturePrelevement',
      'temperatureReception',
      'departementName',
      'dateProduction',
      'dateLimiteConsommation',
      'referenceInterne',
      'dureeRespectee',
       'scelleIntact',
      'propreteContamination',
      'etiquetageLisible',
      'volumeSuffisant'
    ];

    this.displayedColumns = parsedCols.filter((col: string) =>
      validColumns.includes(col)
    );
  }
}

@ViewChild('rapportModal') rapportModal!: TemplateRef<any>;

lqValue: number | null = null;
selectedTechnique: string = '';
techniques: string[] = ['LC-MS/MS', 'GC-MS/MS', 'Autre'];


openRapportModal(rapportModal: any) {
  this.modalService.open(rapportModal, {
    size: 'md',
    centered: true,   // 🔥 وسط الشاشة
    backdrop: true,
    keyboard: true
  });
}


showRapportForm: boolean = false;
generateRapport() {
  console.log('🚀 [generateRapport] Début génération rapport');

  this.loadingRapport = true;
  console.log('⏳ loadingRapport = true');

  this.selectedSampl = new Set(
    this.dataSource1.filteredData.filter(s => this.selectedSamplIds.has(s.sampleAnalyseId))
  );

  console.log('📦 Nombre d\'échantillons sélectionnés :', this.selectedSampl.size);
  if (this.selectedSampl.size < 1) {
    console.warn('⚠️ Aucun échantillon sélectionné');
    this.dialogService.openDangerDialog('Aucun échantillon sélectionné');
    this.loadingRapport = false;
    console.log('⛔ loadingRapport = false (aucun échantillon)');
    return;
  }

  // --- Filtrer les non conformes si besoin ---
  const conformes = Array.from(this.selectedSampl)
    .filter((s: SampleAnalyseResponseDto) => s.status !== 'NON_CONFORME');
  const nonConformes = Array.from(this.selectedSampl)
    .filter((s: SampleAnalyseResponseDto) => s.status === 'NON_CONFORME');

  console.log('✅ Échantillons conformes :', conformes.length);
  console.log('⚠️ Échantillons non conformes ignorés :', nonConformes.length);

  if (nonConformes.length > 0) {
    this.dialogService.openDangerDialog(
      `${nonConformes.length} échantillon(s) non conforme(s) ont été ignoré(s) lors de la génération du rapport.`
    );
  }

  if (conformes.length === 0) {
    console.warn('❌ Aucun échantillon conforme, génération annulée');
    this.loadingRapport = false;
    return;
  }

  // --- Construction du payload avec sampleId et format ---
  const payload = {
    sampleIds: conformes.map(s => s.sampleAnalyseId),
    country: this.rapportForm.country,
    technique: this.rapportForm.technique,
    //lq: this.rapportForm.lq,
    format: this.rapportForm.format // 'pdf' ou 'word'
  };

  console.log('📦 Payload envoyé au backend :', payload);

  // --- Appel backend ---
  console.log('📡 Appel sampleService.generateRapport(...)');
  this.sampleService.generateRapport(payload).subscribe({
    next: (response: any) => {
      console.log('✅ Réponse reçue du backend :', response);

      // --- Afficher warnings éventuels ---
      if (response.warnings && response.warnings.length > 0) {
        response.warnings.forEach((warn: string) => {
          console.warn('⚠️ Warning backend :', warn);
          this.dialogService.openDangerDialog(warn);
        });
      }

      // --- Télécharger les fichiers ---
      if (response?.data && response.data.length > 0) {
        console.log(`📄 Nombre de fichiers reçus = ${response.data.length}`);

        const mimeType = this.rapportForm.format === 'word' 
          ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          : 'application/pdf';
        const extension = this.rapportForm.format === 'word' ? 'docx' : 'pdf';

        response.data.forEach((base64: string, index: number) => {
          console.log(`📑 Traitement fichier #${index + 1}`);
          const blob = this.base64ToBlob(base64, mimeType);
          const url = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = url;

          const sampleCode = conformes[index]?.sampleCode || (index + 1);
          a.download = `rapport_${sampleCode}.${extension}`;
          a.click();

          URL.revokeObjectURL(url);
        });
      } else {
        console.warn('⚠️ Aucun fichier généré par le backend');
      }

      // --- Réinitialisation ---
      this.loadingRapport = false;
      this.isAllSamplesSelected = false;
      this.selectedSampl.clear();
      console.log('✅ loadingRapport = false, sélection réinitialisée');
    },

    error: (err) => {
      console.error('❌ Erreur lors de la génération du rapport', err);
      this.handleErrors.catchError(err);
      this.loadingRapport = false;
      console.log('⛔ loadingRapport = false (erreur)');
    }
  });
}



rapportForm = {
  country: 'FR',
  technique: 'LC_MS_MS',
  //lq: 0.01,
  format:''
};

toggleRapportForm(event: Event) {
  event.stopPropagation();
  this.showRapportForm = !this.showRapportForm;
}

confirmAndGenerateRapport() {
  this.showRapportForm = false;
  this.modalService.dismissAll();
  this.generateRapport();
}


    
    base64ToBlob(base64: string, mimeType: string) {
        const byteCharacters = atob(base64);
        const byteArrays = [];
    
        for (let offset = 0; offset < byteCharacters.length; offset += 1024) {
            const slice = byteCharacters.slice(offset, offset + 1024);
            const byteNumbers = new Array(slice.length);
    
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
    
            byteArrays.push(new Uint8Array(byteNumbers));
        }
    
        return new Blob(byteArrays, { type: mimeType });
    }
    

downloadExcel() {
    console.log("========== DOWNLOAD EXCEL START ==========");

    this.loadingExcel = true;

    console.log("selectedSamplIds:", [...this.selectedSamplIds]);
    console.log("selectedSampl:", [...this.selectedSampl]);

    const selectedSamples: SampleAnalyseResponseDto[] =
        [...this.selectedSampl];

    console.log("📦 selectedSamples:", selectedSamples);
    console.log("📊 selectedSamples length:", selectedSamples.length);

    if (selectedSamples.length === 0) {
        console.error("❌ selectedSampl est vide");

        this.dialogService.openDangerDialog(
            "Aucun échantillon sélectionné"
        );

        this.loadingExcel = false;
        return;
    }

    try {
        const ws: XLSX.WorkSheet =
            XLSX.utils.json_to_sheet(selectedSamples);

        console.log("✅ Worksheet créée :", ws);
        console.log("📐 Worksheet !ref :", ws["!ref"]);

        const wb: XLSX.WorkBook = {
            Sheets: {
                data: ws
            },
            SheetNames: ["data"]
        };

        XLSX.writeFile(
            wb,
            "samples_data.xlsx"
        );

        console.log("✅ Excel généré avec succès");

    } catch (error) {
        console.error("❌ Erreur génération Excel :", error);

        this.dialogService.openDangerDialog(
            "Erreur lors de la génération du fichier Excel"
        );

    } finally {
        this.loadingExcel = false;
    }
}

    openImportModal(importModal: any) {
        this.modalService.open(importModal, {ariaLabelledBy: 'modal-basic-title', size: 'lg'})
    }
    
    generateOT() {
        this.loadingOT = true;    
        console.log("📤 Données envoyées :", JSON.stringify([...this.selectedSamples].map(sample => sample.id), null, 2));   
    
        this.analyseService.generateOT([...this.selectedSamples])
        .subscribe({
            next: res => {
                console.log("✅ Réponse API :", res); // Affiche la réponse complète pour déboguer
    
                if (res?.status) {
                    this.fetchSampleList(); // Si l'OT est générée avec succès, rafraîchir la liste des échantillons
                    this.dialogService.openSuccessDialog(res.message); // Afficher le message de succès
                    console.log(res.message); // Afficher le message des analyses créées
                } else {
                    this.dialogService.openDangerDialog(res?.message || "Erreur inconnue");
                }
            },
            error: err => {
                console.error("❌ Erreur API :", err);
                this.dialogService.openDangerDialog("Erreur lors de la génération de l'OT");
            }
        });
    }
generateAnalyseResults() {
    if (!this.selectedSamplIds || this.selectedSamplIds.size === 0) {
        console.warn("⚠️ Aucun élément sélectionné");
        this.dialogService.openDangerDialog("Aucune analyse sélectionnée");
        return;
    }

    const sampleAnalyseIds: number[] = Array.from(this.selectedSamplIds);

    console.log("📤 SampleAnalyse IDs envoyés :", sampleAnalyseIds);

    this.loadingOT = true;

    this.analyseService.generateAnalyseResults(sampleAnalyseIds).subscribe({
        next: (res) => {
            console.log("✅ Réponse API :", res);

            if (res?.status) {
                this.fetchSampleList();
                this.dialogService.openSuccessDialog(res.message);
                this.selectedSamplIds.clear(); // Reset sélection après génération
                this.isAllSamplesSelected = false;
            } else {
                this.dialogService.openDangerDialog(res?.message || "Erreur inconnue");
            }

            this.loadingOT = false;
        },
        error: (err) => {
            console.error("❌ Erreur API :", err);
            this.dialogService.openDangerDialog(
                "Erreur lors de la génération des résultats d'analyse"
            );
            this.loadingOT = false;
        }
    });
}


event: any | null = null;


btnAddFromText() {
    console.log('btnAddFromText triggered');

    const input = this.event.target as HTMLInputElement;
    console.log('Input element:', input);

    if (input.files && input.files[0]) {
        const file = input.files[0];
        console.log('File selected:', file);

        const reader = new FileReader();

        reader.onload = () => {
            const text = reader.result as string;
            console.log('File content loaded:', text);

            const dataFile = this.sampleService.parseFileData(text);
            console.log('Parsed dataFile:', dataFile);

            this.sampleService.createFromTextFile(dataFile).subscribe({
                next: (res) => {
                    console.log('Response from createFromTextFile:', res);

                    if (res.status) {
                        this.dataSource.data = res.data;
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog("");
                    } else {
                        this.dialogService.openDangerDialog("");
                    }
                    this.event = null;
                },
                error: err => {
                    console.error('Error from createFromTextFile:', err);
                    this.handleErrors.catchError(err);
                    this.event = null;
                }
            });
        };

        reader.readAsText(file);
    } else {
        console.warn('No file selected or input.files is empty');
    }
}



    ex_event: any | null = null;
    btn_ImportFromExcelFile() {
        let samples: SampleDTO[] = [];
        const target: DataTransfer = <DataTransfer>(this.ex_event.target);
    
        if (target.files.length !== 1) {
            console.log("Erreur: Plusieurs fichiers ou aucun fichier sélectionné.");
            this.dialogService.openDangerDialog("Veuillez télécharger un seul fichier.");
            return;
        }
    
        const file = target.files[0];
        console.log("Fichier sélectionné:", file.name);
    
        const reader: FileReader = new FileReader();
    
        reader.onload = (e: any) => {
            const binaryData = e.target.result;
            console.log("Données binaires lues du fichier.");
    
            const workbook: XLSX.WorkBook = XLSX.read(binaryData, { type: 'binary' });
            console.log("Classeur Excel chargé. Noms des feuilles:", workbook.SheetNames);
    
            const sheetName: string = workbook.SheetNames[0];
            console.log("Nom de la première feuille:", sheetName);
    
            const sheet: XLSX.WorkSheet = workbook.Sheets[sheetName];
            console.log("Données de la feuille:", sheet);
    
            samples = XLSX.utils.sheet_to_json(sheet);
            console.log("Échantillons extraits de la feuille Excel:", samples);
    
            // Enregistrement des échantillons extraits
            this.sampleService.saveFormExcelFile(samples).subscribe({
                next: response => {
                    console.log("Réponse de l'API:", response);
    
                    if (response.status) {
                        this.modalService.dismissAll();
                        this.dialogService.openSuccessDialog("Échantillons créés avec succès");
                        this.fetchSampleList()
                    } else {
                        this.dialogService.openDangerDialog("Erreur inattendue: lors de la création d'échantillons");
                    }
                    this.ex_event = null;
                },
                error: err => {
                    console.error("Erreur lors de l'enregistrement des échantillons:", err);
                    this.modalService.dismissAll();
                    this.handleErrors.catchError(err);
                    this.ex_event = null;
                }
            });
        };
    
        reader.readAsBinaryString(file);
    }
    
}
